import React from 'react';
import { LinkedinIcon } from 'lucide-react';
const LINK_GROUPS = [{
  title: 'Company',
  links: [{
    label: 'Approach',
    href: '#approach'
  }, {
    label: 'Services',
    href: '#services'
  }, {
    label: 'Method',
    href: '#method'
  }, {
    label: 'About',
    href: '#about'
  }]
}, {
  title: 'Services',
  links: [{
    label: 'Brand & Positioning',
    href: '#services'
  }, {
    label: 'Marketing Automation',
    href: '#services'
  }, {
    label: 'Sales Conversion',
    href: '#services'
  }, {
    label: 'AI-Powered Growth',
    href: '#services'
  }]
}];
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-950 text-white" data-id="element-50" data-mp="3ldu8l5f6f825">
      <div className="mx-auto max-w-container px-6 py-16 lg:px-8" data-id="element-51" data-mp="3qc41189inuk2">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr]" data-id="element-52" data-mp="29zgnu9fpz8qc">
          <div data-id="element-53" data-mp="2a19qldn7p8t2">
            <a href="#top" className="flex items-center gap-2.5" data-id="element-54" data-mp="2eya0y0r3gxpz">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-gold-500 font-display text-lg font-semibold text-ink-950" data-id="element-55" data-mp="2ezl541ogc7hm">
                M
              </span>
              <span className="font-display text-xl font-semibold tracking-tight" data-id="element-56" data-mp="3gbqx8d534h9u">
                MAEDSO
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-57" data-mp="3q8mypywkg34w">
              Maximizing Education Solutions. Growth systems for the leaders shaping
              the future of education.
            </p>
            <a href="https://www.linkedin.com/in/hbdotson4/" target="_blank" rel="noreferrer" aria-label="Henry B. Dotson on LinkedIn" className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-gold-500 hover:text-gold-400" data-id="element-58" data-mp="34gvzesy8n6j">
              <LinkedinIcon className="h-5 w-5" data-id="element-59" data-mp="msg8ov72q4el" />
            </a>
          </div>

          {LINK_GROUPS.map(group => <div key={group.title} data-id="element-60" data-mp="tw5wk16p5gk3">
              <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-white/50" data-id="element-61" data-mp="tt090qdpumqh">
                {group.title}
              </h3>
              <ul className="mt-4 space-y-3" data-id="element-62" data-mp="13sr6n0xkphus">
                {group.links.map(link => <li key={link.label} data-id="element-63" data-mp="18kiwtacthlke">
                    <a href={link.href} className="text-sm text-white/70 transition-colors hover:text-white" data-id="element-64" data-mp="18lk6bae6q000">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/50 sm:flex-row sm:items-center" data-id="element-65" data-mp="1riv6cx7n4xgi">
          <span data-id="element-66" data-mp="3ocpy1jok63yr">© {new Date().getFullYear()} MAEDSO. All rights reserved.</span>
          <span data-id="element-67" data-mp="3tb9kdl72dhrn">Scottsdale, Arizona</span>
        </div>
      </div>
    </footer>;
}